import React from 'react';

import { SVGComponentProps } from './svg.types';

const FilterTickMarkSVG = ({ size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <g clipPath="url(#clip0_3862_202302)">
        <path
          d="M8.97261 16.774L5.49961 13.3C5.34029 13.1408 5.21391 12.9518 5.12768 12.7437C5.04145 12.5357 4.99707 12.3127 4.99707 12.0875C4.99707 11.8623 5.04145 11.6392 5.12768 11.4312C5.21391 11.2232 5.34029 11.0341 5.49961 10.875C5.82135 10.5537 6.25744 10.3732 6.71211 10.3732C7.16678 10.3732 7.60287 10.5537 7.92461 10.875L10.0996 13.048C10.1435 13.0916 10.2028 13.116 10.2646 13.116C10.3264 13.116 10.3858 13.0916 10.4296 13.048L16.0696 7.40796C16.3913 7.0867 16.8274 6.90625 17.2821 6.90625C17.7368 6.90625 18.1729 7.0867 18.4946 7.40796C18.6539 7.56714 18.7803 7.75615 18.8665 7.9642C18.9528 8.17225 18.9971 8.39525 18.9971 8.62046C18.9971 8.84567 18.9528 9.06867 18.8665 9.27672C18.7803 9.48477 18.6539 9.67378 18.4946 9.83296L11.5546 16.774C11.2122 17.1163 10.7478 17.3086 10.2636 17.3086C9.77941 17.3086 9.31504 17.1163 8.97261 16.774Z"
          fill="#BCBEC2"
        />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      <defs>
        <clipPath id="clip0_3862_202302">
          <rect width="14" height="14" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FilterTickMarkSVG;
